/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Cargos.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/cargos',
    name: 'cargos.index',
    component: () => import('./views/CargosIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'cargos.read',
      title: 'Cargos',
    },
  },
]

export default routes
